export const DEFAULT_ONBOARDING_SUPPORTS = [
  {
    checked: false,
    label: "会社寮完備",
  },
  {
    checked: false,
    label: "特定技能2号受験サポート",
  },
  {
    checked: false,
    label: "生活支援・母国語対応サポート",
  }
];

export const DEFAULT_SELF_EXPENSES = [
  {
    checked: false,
    label: "国内移動費本人負担",
  },
  {
    checked: false,
    label: "ビザ申請印紙代本人負担",
  },
  {
    checked: false,
    label: "住居入居における初期費用負担",
  }
];
